<template>
    <m-filter :text="text" :popup.sync="popup" :filtered="value">
        <div class="m-2 bg-white">
            <div class="text-sm cursor-pointer hover_bg-primary-600 hover_text-white" @click="apply(true)"
                 :class="{'text-primary-600': value === true }">True
            </div>
            <div class="text-sm cursor-pointer hover_bg-primary-600 hover_text-white" @click="apply(false)"
                 :class="{'text-primary-600': value === false }">False
            </div>
            <div class="text-sm cursor-pointer hover_bg-primary-600 hover_text-white" @click="apply(null)"
                 :class="{'text-primary-600': value === null }">All
            </div>
        </div>
    </m-filter>
</template>

<script>
export default {
    props: {
        text: String,
        value: {
            type: Boolean,
            default: null
        }
    },
    data() {
        return {
            search: this.value,
            popup: false
        }
    },
    methods: {
        apply(val) {
            this.$emit('apply', val)
            this.popup = false
        }
    }
}
</script>

